module.exports = __webpack_public_path__ + "assets/filter-scoober-delivery-c77642.svg";